import React from "react";
import { useDayPlan } from "../../DayPlanProvider";

export const ActionButtons: React.FC = () => {
  const { currentDayIndex, copyFromPreviousDay, isLoading } = useDayPlan();

  // const canCopyFromPrevious = currentDayIndex > 0;
  console.log("canCopyFromPrevious", currentDayIndex > 0);
  const canCopyFromPrevious = false;

  return (
    <div className="flex items-center space-x-3">
      {canCopyFromPrevious && (
        <button
          onClick={copyFromPreviousDay}
          disabled={isLoading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          🔄 Kopiuj z poprzedniego dnia
        </button>
      )}
    </div>
  );
};
